import {
  CalendarOutlined,
  CheckCircleOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons';
import { isAfter, isBefore } from 'date-fns';

import { CouponPhysic } from 'src/models';

import { TColumnCouponPhysicOrder } from '../TablePhysic.coupons';

export function getStatusEnumByDates(
  initDate: Date,
  finishDate: Date,
  current: Date
) {
  if (isBefore(current, initDate)) return CouponPhysic.StatusEnum.SCHEDULE;

  if (isAfter(current, finishDate)) return CouponPhysic.StatusEnum.FINISH;

  return CouponPhysic.StatusEnum.ACTIVE;
}

export function parseOrderFilter(orderColumn: string) {
  switch (orderColumn) {
    case 'dateInit':
      return 'start_date';
    case 'dateFinish':
      return 'end_date';
    default:
      return orderColumn;
  }
}

export function getInfoStatus(status: CouponPhysic.StatusEnum) {
  switch (status) {
    case CouponPhysic.StatusEnum.ACTIVE:
      return {
        Icon: CheckCircleOutlined,
        color: 'success',
        text: 'Ativo',
      };
    case CouponPhysic.StatusEnum.FINISH:
      return {
        Icon: MinusCircleOutlined,
        color: 'processing',
        text: 'Finalizado',
      };
    case CouponPhysic.StatusEnum.SCHEDULE:
      return {
        Icon: CalendarOutlined,
        color: 'warning',
        text: 'Agendado',
      };
    default:
      return {
        Icon: CalendarOutlined,
        color: 'error',
        text: 'Inativo',
      };
  }
}

export function tableColumnCouponPhysicOrderDefined(
  key: string,
  orderColumn: TColumnCouponPhysicOrder | null
) {
  if (!orderColumn) return undefined;

  return orderColumn.column !== parseOrderFilter(key)
    ? undefined
    : orderColumn.inverse
    ? 'ascend'
    : 'descend';
}
